export default "__VITE_ASSET__8B0oaKPj__"